<div *ngIf="dataSource">

  <div fxFlex="100" fxFlex.lt-md="100">
    <mat-card class="table-card" appCard>
      <mat-card-content>
        <table mat-table style="width: 100%" [dataSource]="dataSource">

          <ng-container
            *ngFor="let column of parent; let i = index; first as first"
            [matColumnDef]="column"
          >
            <th mat-header-cell *matHeaderCellDef style="text-align: center">
              {{ labels[column] | translate }}
            </th>

            <td
              mat-cell
              *matCellDef="let data"
              style="text-align: center; padding-right: 4%"
            >
              <button
                mat-icon-button
                [style.visibility]="!data.expandable ? 'hidden' : ''"
                [style.marginLeft.px]="data.level * 32"
                (click)="treeControl.toggle(data)"
              >
                <mat-icon class="mat-icon-rtl-mirror">
                  {{
                    treeControl.isExpanded(data)
                      ? "expand_more"
                      : "chevron_right"
                  }}
                </mat-icon>
              </button>

              <ng-container *ngIf="withcheckbok">

                <mat-checkbox
                  [disabled]="
                    data.ardExistConsor == 1 || data.ardExistConsorMem == 1
                  "


                  class="checklist-leaf-node"
                  *ngIf="
                    getParentNode(data) != null &&data?.islot!='islot' "

                  [checked]="checklistSelection.isSelected(data)"
                  (change)="todoLeafItemSelectionToggle(data)"
                  >{{ data.bidCls }}</mat-checkbox
                >

                <mat-checkbox
                        class="checklist-leaf-node"
                  [disabled]="
                    data.ardExistConsor == 1 || data.ardExistConsorMem == 1
                  "
                  *ngIf="getParentNode(data) == null"
                  [indeterminate]="descendantsPartiallySelected(data)"
                  (change)="todoItemSelectionToggle(data)"
                  >{{ data.bidCls }}</mat-checkbox
                >
              </ng-container>

              <ng-container
                *ngIf="!withcheckbok||data?.islot=='islot' "

              >
                {{ data.bidCls }}
              </ng-container>
            </td>
          </ng-container>

          <ng-container
            *ngFor="let column of getcoulum(); let i = index; first as first"
            [matColumnDef]="column"
          >
            <th mat-header-cell *matHeaderCellDef style="text-align: center">
              {{ labels[column] | translate }}
            </th>

            <td mat-cell *matCellDef="let type" >
              {{ type[column] | typedValue | async | translate }}
            </td>
          </ng-container>
          <ng-container matColumnDef="envoi">
            <th *matHeaderCellDef mat-header-cell style="text-align: center">
              {{ labels.envoi | translate }}
            </th>
            <td *matCellDef="let offre" mat-cell >
              {{ getmsg(offre) | translate }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="readColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: readColumns"></tr>
        </table>

        <app-empty-list-container
          [withoutBorder]="true"
          [list]="dataSource.data"
        >
        </app-empty-list-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
